var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCameraEmptyDisabled = function SvgCameraEmptyDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 22.595 7.454 5.738H8.546L16 22.595Z",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.333 5.104 3.219 3.22l24.513 24.513-1.886 1.886z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97 6.971a10.287 10.287 0 0 0-1.303 5.03c0 5.706 4.626 10.333 10.333 10.333 1.826 0 3.54-.474 5.03-1.305l-1.486-1.484A8.333 8.333 0 0 1 8.456 8.456L6.97 6.971Zm3.832 3.831a5.333 5.333 0 0 0 6.396 6.396l-6.396-6.396Zm8.853 5.082-7.539-7.539a5.333 5.333 0 1 1 7.539 7.539Zm2.122 2.122A8.333 8.333 0 1 0 9.994 6.223L8.58 4.81A10.303 10.303 0 0 1 16 1.667c5.707 0 10.333 4.626 10.333 10.333 0 2.912-1.204 5.542-3.141 7.42l-1.415-1.414Z",
    fill: "#fff"
  })));
};
export default SvgCameraEmptyDisabled;